import {
  GetResultLabelConceptMappingsDocument,
  GetResultLabelConceptMappingsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type ResultLabelConceptMapping =
  GetResultLabelConceptMappingsQuery['payroll']['resultLabelConceptMappings'][number]

export const useResultLabelConceptMappings = () => {
  const { loading, data } = useQuery(GetResultLabelConceptMappingsDocument)

  return {
    loading,
    resultLabelConceptMappings: data ? data.payroll.resultLabelConceptMappings : [],
  }
}
